import { memo } from "react";
import { Grid, Radio } from "semantic-ui-react";
import { IP_VERSIONS } from "../../constants";
import { HandleCheckboxChange } from "../../../../../../custom-hooks/form/types";

type IPVersionProps = {
  onChange: HandleCheckboxChange;
  ipVersion: number;
  index: number;
};

const IPVersion = ({ onChange, ipVersion, index }: IPVersionProps) => {
  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-30"
      >
        <h5>IP Version</h5>
      </Grid.Column>
      {IP_VERSIONS.map((version) => (
        <Grid.Column
          key={`radio${version}`}
          textAlign="left"
          width={4}
          className="margin-top-30"
        >
          <Radio
            className="simple-radio"
            label={`IPv${version}`}
            name={`ipVersion-${index}`}
            value={version}
            checked={ipVersion === version}
            onChange={onChange}
          />
        </Grid.Column>
      ))}
    </>
  );
};

export default memo(IPVersion);
